<template>
  <div class="wrapper">
    <div class="header">
      <el-upload :show-file-list="false" :before-upload="beforeUpload" :http-request="httpRequest" :disabled="upload"
        action="/" accept=".accdb">
        <el-button v-if="exportLayer" icon="el-icon-download" class="upload" size="small" type="primary"
          style="float:left" @click="upLoadFile">
          导入
        </el-button>
      </el-upload>
    </div>
    <div class="aside">
      <div v-for="(aside, i) in asideInfo" :key="i" :class="{ 'filter-card': true, active: aside.isOpen }">
        <div class="filter-card-header" @click="aside.isOpen = !aside.isOpen">
          {{ aside.label }}
          <i class="el-icon-arrow-up" />
        </div>
        <el-collapse-transition>
          <ul v-show="aside.isOpen" class="filter-card-body">
            <li v-for="{ name, id } in dict.specialty" :key="id" :class="{ active: aside.active === id }"
              @click="aside.active = aside.active === id ? '' : id">
              <img :src="folderIcon" alt="" />
              {{ name }}
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
    <div class="wrapper_main">
      <div class="bar">
        <el-button v-if="deletLayer" :disabled="!selection.length" type="danger" plain size="small"
          icon="el-icon-copy-document" @click="deleteLayers()">
          批量删除
        </el-button>
      </div>
      <div class="content">
        <el-table :data="list" border height="100%" @selection-change="(se) => (selection = se)">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column type="selection" align="center" />
          <el-table-column :index="(page.pageIndex - 1) * page.pageSize + 1" type="index" label="序号" width="60px"
            align="center" />
          <el-table-column label="提资专业" width="100px" prop="carrySpec" />
          <el-table-column label="接收专业" width="100px" prop="receiveSpec" />
          <el-table-column label="图层表单名称" prop="layerTableName" min-width="200px" />
          <el-table-column label="附加图名" prop="additionLayerName" min-width="200px" />
          <el-table-column label="图层名" prop="layerName" min-width="200px" />
          <el-table-column label="颜色" prop="colour" width="100px" />
          <el-table-column label="线型" prop="lineType" width="100px" />
          <el-table-column label="线宽" prop="lineWeight" width="100px" />
          <el-table-column label="打印样式" prop="plotStyle" width="100px" />
          <el-table-column label="是否打印" width="80px" prop="isPrint">
            <template #default="{ row: { isPrint } }">
              {{ ['否', '是'][isPrint] }}
            </template>
          </el-table-column>
          <el-table-column label="说明" prop="specification" min-width="200px" />
          <el-table-column label="是否提取" prop="isForien" width="80px">
            <template #default="{ row: { isForien } }">
              {{ ['否', '是'][isForien] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template #default="{ row: { layerId } }">
              <el-button type="text" @click="deleteLayers([layerId])">
                <span class="text-primary">删除</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination :total="page.totalCount" :current-page="page.pageIndex" :page-size="page.pageSize"
          :page-sizes="[10, 20, 50, 100]" background layout="total,sizes, prev, pager, next,jumper"
          @size-change="handleSizeChange" @current-change="getList" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  carryInfoGetSpecialty,
  carryInfoGetLayerList,
  carryInfoDeleteLayers,
  carryInfoImportAccessFile
} from "@/CommonDP/service/tz-service";
import { mapState } from "vuex";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
export default {
  name: "ProvideInformationLayer",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      folderIcon: require("@/CommonDP/assets/doc/folder_icon.png"),
      upload: false,
      dict: {
        specialty: []
      },
      list: [],
      selection: [],
      page: { pageIndex: 1, pageSize: 15, totalCount: 0 },
      asideInfo: [
        { isOpen: true, active: "", label: "提资专业" },
        { isOpen: true, active: "", label: "接收专业" }
      ],
      exportLayer: checkPermission(this.$allPerms.PROVIDEINFORMATIONLAYER_EXPORT),
      deletLayer: checkPermission(this.$allPerms.PROVIDEINFORMATIONLAYER_DALE)
    };
  },
  computed: {
    queryData() {
      const map = {
        type: 0
      };
      map.carrySpecId = this.asideInfo[0].active;
      map.receiveSpecId = this.asideInfo[1].active;
      return map;
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    queryData() {
      this.getList(1);
    }
  },
  created() {
    this.getDict();
    this.getList(1);
  },
  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1);
    },
    async beforeUpload({ name }) {
      return /\.accdb$/.test(name);
    },
    upLoadFile() {
      const a = disablePrompt();
      if (!a) {
        this.upload = true;
      }
    },
    async httpRequest({ file }) {
      await this.$confirm("导入文件将会更新已有的图层信息", "警告", {
        type: "warning"
      });
      const data = new FormData();
      data.append("file", file);
      try {
        this.upload = true;
        await carryInfoImportAccessFile(data);
        this.getList();
      } finally {
        this.upload = false;
      }
    },
    async getDict() {
      const { data } = await carryInfoGetSpecialty();
      this.dict.specialty = data;
    },
    async getList(pageNo = this.page.pageIndex) {
      const { data, pageIndex, totalCount, pageSize } = await carryInfoGetLayerList({
        ...this.queryData,
        pageNo,
        pageSize: this.page.pageSize,
        enterpriseId: this.enterpriseId
      });
      this.list = data;
      this.page.pageIndex = pageIndex;
      this.page.totalCount = totalCount;
      this.page.pageSize = pageSize;
    },
    async deleteLayers(list = this.selection.map(({ layerId: id }) => id)) {
      const a = disablePrompt();
      if (a) {
        await this.$confirm(`您确定删除选中图层吗`, "警告", {
          type: "wanrning"
        });
        await carryInfoDeleteLayers(list);
        this.getList(1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$header-height: 36px;
$aside-width: 210px;
$bar-height: 48px;
$page-height: 36px;
$border-color: #ebefff;
.text-primary {
  color: #d30521;
}
.wrapper {
  height: 100%;
  position: relative;
  background-color: #fff;
  .header {
    padding: 8px 16px;
    height: $header-height;
    border-bottom: 1px solid $border-color;
  }
  .aside {
    border-right: 1px solid $border-color;
    position: absolute;
    width: $aside-width;
    top: $header-height + 20px;
    bottom: 0;
    left: 0;
    padding: 12px;
    overflow: auto;
    .filter-card {
      $filter-height: 32px;
      transition: all 0.2s;
      margin: 2px 0 0;
      &.active {
        .filter-card-header > i {
          transform: rotate(180deg);
        }
      }
      &-header {
        line-height: $filter-height;
        padding: 0 8px;
        height: $filter-height;
        background-color: #f7f9ff;
        cursor: pointer;
        > i {
          transition: all 0.2s;
          line-height: $filter-height;
          float: right;
        }
      }
      &-body {
        overflow: auto;
        > li {
          // font-size: 14px;
          padding: 0 30px;
          border-radius: 15px;
          margin: 2px 0;
          cursor: pointer;
          transition: all 0.2s;
          line-height: 26px;
          > img {
            height: 14px;
            line-height: 16px;
            margin-right: 4px;
          }
          &.active,
          &:hover {
            background-color: #f7f9ff;
          }
        }
      }
    }
  }

  .wrapper_main {
    position: absolute;
    top: $header-height + 20px;
    bottom: 0;
    right: 5px;
    left: $aside-width + 30px;
    .bar {
      padding: 8px;
      border-bottom: 1px solid $border-color;
      height: $bar-height;
    }
    .content {
      position: absolute;
      top: $bar-height;
      bottom: $page-height;
      right: 0;
      left: 0;
    }
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: right;
      height: $page-height;
    }
  }
}
</style>
